// extracted by mini-css-extract-plugin
module.exports = {"loader_area":"pageloader_loader_area__39QeL"};